export default {
  about: 'Informazioni',
  addOns: 'Estensioni',
  agenda: 'Programma',
  all: 'Tutti',
  browse: 'Esplora',
  buyTickets: 'Compra i biglietti',
  countSelected: '{{count}} selezionati',
  included: 'Incluso',
  joinWaitlist: "Unisciti alla lista d'attesa",
  joining: 'In corso',
  menu: 'Menu',
  noDatesAvailable: 'Nessuna data disponibile',
  salesEnded: 'Vendite terminate',
  schedule: 'Calendario',
  seeMoreDates: 'Vedi altre date',
  soldOut: 'Esaurito',
  viewMore: 'Vedi di più',
  viewLess: 'Vedi meno',
  location: 'Posizione',
  time: 'Orario',
  at: 'a',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Nessun orario disponibile in questa data per questo numero di persone',
  availableTimes: 'Orari disponibili',
  waitlist: "Lista d'attesa",
  continue: 'Continua',
  tickets: 'Biglietti',
  ticketsAreNoLongerAvailable: 'I biglietti non sono più disponibili.',
  checkOutOutOtherExperiences: 'Scopri le nostre altre esperienze!',
  viewExperiences: 'Vedi esperienze',
  from: 'da',
  cancellationPolicy: 'Politica di cancellazione',
  rsvp: 'RSVP',
  nights: 'notti',
  request: 'Richiesta',
  arrival: 'Arrivo',
  departure: 'Partenza',
};
